<template>
  <div class="page-common-container" v-loading="loading">
    <div class="page-common-container-left">
      <pageForm ref="pageForm" :title="$i18n.$t('人物筛选')" :btnName="$i18n.$t('查询')" :fields="fields" @search="getTimeGraph" />
    </div>
    <div class="page-common-container-right">
      <div class="page-common-container-right-content hasName">
        <div ref="myEcharts" id="myEcharts" style="width: 100%;height: 100%;"></div>
      </div>
      <div class="page-common-container-right-list hasName">
        <div class="page-common-container-right-list-title">
          <div class="page-common-container-right-list-title-top">
            <div class="page-common-container-right-list-title-top-name">{{ $i18n.$t('查询结果') }}</div>
            <el-button type="primary" @click.stop="exportData" :disabled="!graphData.length || downloadLoading" :loading="downloadLoading">{{ $i18n.$t('导出数据') }}</el-button>
          </div>
        </div>
        <div class="page-common-container-right-list-content">
          <div class="page-common-container-right-list-content-item">
            <div class="page-common-container-right-list-content-item-title">
              <div class="page-common-container-right-list-content-item-title-name">{{ $i18n.$t('朝代人物数据') }}</div>
              <div class="page-common-container-right-list-content-item-title-count">{{ $i18n.$t('关系数据：') }}{{ sidebar.person_count }}{{ $i18n.$t('条') }}</div>
            </div>
            <div class="page-common-container-right-list-content-item-table">
              <div class="page-common-container-right-list-content-item-table-head">
                <div class="page-common-container-right-list-content-item-table-head-th" style="flex: 1;">{{ $i18n.$t('人物名称') }}</div>
                <div class="page-common-container-right-list-content-item-table-head-th" style="flex: 1;">{{ $i18n.$t('朝代') }}</div>
                <div class="page-common-container-right-list-content-item-table-head-th" style="flex: 1;">{{ $i18n.$t('类别') }}</div>
              </div>
              <template v-for="(row, index) in sidebar.person">
                <div class="page-common-container-right-list-content-item-table-row" v-if="sidebar.showPerMore || (!sidebar.showPerMore && index < 4)" :key="index">
                  <div class="page-common-container-right-list-content-item-table-row-td" style="flex: 1;" :title="row.name">{{ row.name }}</div>
                  <div class="page-common-container-right-list-content-item-table-row-td" style="flex: 1;">{{ row.dynasty }}</div>
                  <div class="page-common-container-right-list-content-item-table-row-td" style="flex: 1;">{{ row.category || $i18n.$t('其他') }}</div>
                </div>
              </template>
            </div>
            <div class="page-common-container-right-list-content-item-more" v-if="sidebar.person.length > 4" @click.stop="sidebar.showPerMore = !sidebar.showPerMore">
              <template v-if="sidebar.showPerMore">
                {{ $i18n.$t('收起') }}
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                {{ $i18n.$t('查看更多') }}
                <i class="el-icon-arrow-down"></i>
              </template>
            </div>
          </div>
          <!-- <div class="page-common-container-right-list-content-item">
            <div class="page-common-container-right-list-content-item-title">
              <div class="page-common-container-right-list-content-item-title-name">朝代著作数据</div>
              <div class="page-common-container-right-list-content-item-title-count">关系数据：{{ sidebar.work_count }}条</div>
            </div>
            <div class="page-common-container-right-list-content-item-table">
              <div class="page-common-container-right-list-content-item-table-head">
                <div class="page-common-container-right-list-content-item-table-head-th" style="flex: 1;">著作名称</div>
                <div class="page-common-container-right-list-content-item-table-head-th" style="flex: 1;">朝代</div>
              </div>
              <template v-for="(row, index) in sidebar.works">
                <div class="page-common-container-right-list-content-item-table-row" v-if="sidebar.showWorkMore || (!sidebar.showWorkMore && index < 4)" :key="index">
                  <div class="page-common-container-right-list-content-item-table-row-td" style="flex: 1;" :title="row.name">{{ row.name }}</div>
                  <div class="page-common-container-right-list-content-item-table-row-td" style="flex: 1;">{{ row.dynasty }}</div>
                </div>
              </template>
            </div>
            <div class="page-common-container-right-list-content-item-more" v-if="sidebar.works.length > 4" @click.stop="sidebar.showWorkMore = !sidebar.showWorkMore">
              <template v-if="sidebar.showWorkMore">
                收起
                <i class="el-icon-arrow-up"></i>
              </template>
              <template v-else>
                查看更多
                <i class="el-icon-arrow-down"></i>
              </template>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { timeGraph } from '@/api/home'
import { timeGraphOutput } from '@/api/export'
import { i18n } from '@/i18n'
export default {
  name: 'timeGraph',
  meta: {
    title: i18n.$t('时间图谱')
  },
  data () {
    let sessionParams = sessionStorage.getItem('timeGraphParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    return {
      fields: [
        {
          type: 'select',
          label: i18n.$t('人物分类'),
          placeholder: i18n.$t('全部'),
          key: 'Category',
          clearable: true,
          options: this.$store.state.dict.personCategory || [],
          defaultValue: sessionParams ? (sessionParams.Category || '') : null
        },
        {
          type: 'selectGroup',
          label: i18n.$t('时间'),
          separator: i18n.$t('至'),
          start: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_start',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_start || '') : null
          },
          end: {
            placeholder: i18n.$t('全部'),
            key: 'Dynasty_end',
            options: this.$store.state.dict.allDynasty || [],
            defaultValue: sessionParams ? (sessionParams.Dynasty_end || '') : null
          }
        },
        {
          type: 'select',
          label: i18n.$t('宗派'),
          placeholder: i18n.$t('全部'),
          key: 'Sect',
          clearable: true,
          options: this.$store.state.dict.allSect || [],
          defaultValue: sessionParams ? (sessionParams.Sect || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('传记名称'),
          placeholder: i18n.$t('全部'),
          key: 'Biographie',
          clearable: true,
          options: this.$store.state.dict.biographieName || [],
          defaultValue: sessionParams ? (sessionParams.Biographie || '') : null
        },
        {
          type: 'select',
          label: i18n.$t('人物设置'),
          placeholder: i18n.$t('请选择'),
          key: 'is_extension',
          clearable: true,
          options: [
            { label: i18n.$t('显示所有人物'), value: '1' },
            { label: i18n.$t('仅显示传记人物'), value: '0' }
          ],
          defaultValue: '1'
        }
      ],
      myChart: null,
      graphData: [],
      loading: false,
      sidebar: {
        person: [],
        // works: [],
        person_count: 0,
        // work_count: 0,
        showPerMore: false
        // showWorkMore: false
      },
      downloadLoading: false
    }
  },
  mounted () {
    let sessionParams = sessionStorage.getItem('timeGraphParams')
    if (sessionParams) {
      sessionParams = JSON.parse(sessionParams)
    }
    console.log(sessionParams)
    if (!sessionParams || (sessionParams && !Object.keys(sessionParams).some(e => sessionParams[e]))) {
      this.getTimeGraph({})
    }
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    this.myChart.dispose()
  },
  methods: {
    exportData () {
      const form = this.$refs.pageForm.form || {}
      this.downloadLoading = true
      timeGraphOutput(form).then(res => {
        const a = document.createElement('a')
        a.href = URL.createObjectURL(res)
        a.download = i18n.$t('时间图谱.xlsx')
        a.click()
        URL.revokeObjectURL(a.href)
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    handleResize () {
      this.myChart && this.myChart.resize()
    },
    init () {
      if (this.$refs.myEcharts) {
        this.myChart = echarts.init(this.$refs.myEcharts)
        this.setOption()
      }
    },
    setOption () {
      const that = this
      const series = []
      if (that.graphData[0] && that.graphData[0].category_count) {
        Object.keys(that.graphData[0].category_count).forEach(key => {
          series.push({
            name: key,
            type: 'bar',
            data: 0, // 示例数据
            stack: 'time',
            barWidth: '20px'
          })
        })
        series.forEach(item => {
          const data = that.graphData.map(e => e.dynasty).map(name => {
            const row = that.graphData.find(e => e.dynasty === name)
            return row.category_count[item.name] || 0
          })
          item.data = data
        })
        series.reverse()
      }
      this.myChart.setOption({
        title: {
          show: false
        },
        color: [
          '#987442', '#FF0000', '#2077FC', '#A80326', '#B5756B',
          '#FA8401', '#52B051', '#440459', '#4D6499', '#0B429C',
          '#75C8FC', '#E57394', '#8D3EAC', '#1FDB74', '#849ABA',
          '#A9CAFE', '#C89F24', '#24B9AA', '#FEAAA8', '#C4C54E'
        ],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let res = `<span style="color: #666666">${params[0].name}<span><br/>`
            params.reverse().forEach(function (item) {
              // res += item.seriesName + ': ' + item.value + '<br/>'
              res += `<p style="display: flex;align-items: center;margin-top: 5px;">
                <span style="width: 15px;height: 15px;border-radius: 50%;display: block;background-color: ${item.color};margin-right: 10px"></span>
                <span style="flex: 1;display: block;">${item.seriesName}</span>
                <span style="text-align: right;display: block;margin-left: 20px;font-weight: bold;">${item.value}</span>
                </p>`
            })
            return res
          }
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#333333',
            fontSize: 14,
            rotate: 0,
            formatter: function (value) {
              return value.split('').join('\n')
            },
            lineHeight: 16
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E2E2E2' // y轴线颜色
            }
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          data: that.graphData.map(e => e.dynasty)
        },
        yAxis: {
          type: 'value',
          name: '(数量)',
          nameLocation: 'end',
          splitLine: {
            lineStyle: {
              color: '#E2E2E2'
            }
          },
          nameTextStyle: {
            color: '#333333',
            fontSize: 14,
            padding: [0, 40, 10, 0], // 调整单位位置 [上,右,下,左]
            verticalAlign: 'bottom'
          },
          axisLabel: {
            color: '#999999',
            fontSize: 14
          }
        },
        grid: {
          top: 80,
          left: 80,
          right: 80,
          bottom: 110
        },
        series: series
        // [
        //   {
        //     name: '著作',
        //     type: 'bar',
        //     data: that.graphData.map(e => e.total_work_count), // 示例数据
        //     stack: 'time',
        //     barWidth: '20px'
        //   },
        //   // {
        //   //   name: '地点',
        //   //   type: 'bar',
        //   //   data: [23, 45, 78, 36], // 示例数据
        //   //   stack: 'time',
        //   //   barWidth: '20px'
        //   // },
        //   {
        //     name: '人物',
        //     type: 'bar',
        //     data: that.graphData.map(e => e.person_count), // 示例数据
        //     stack: 'time',
        //     barWidth: '20px'
        //   }
        // ]
      })
    },
    getTimeGraph (params) {
      sessionStorage.setItem('timeGraphParams', JSON.stringify(params))
      this.loading = true
      timeGraph(params).then(res => {
        this.graphData = res.data.data
        this.sidebar = {
          ...res.data.sidebar,
          showPerMore: false
          // showWorkMore: false
        }
        this.init()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
